import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import canonical from "@/lib/canonical.json";

const normalize = (p) => (p.length > 1 ? p.replace(/\/+$/, "") : p);

const setMeta = (selector, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute("content", value);
};

const setCanonical = (href) => {
  const links = Array.from(document.head.querySelectorAll('link[rel="canonical"]'));
  if (!href) {
    links.forEach((l) => l.remove());
    return;
  }
  const [link = document.createElement("link"), ...extra] = links;
  extra.forEach((l) => l.remove());
  link.setAttribute("rel", "canonical");
  link.setAttribute("href", href);
  if (!link.isConnected) document.head.appendChild(link);
};

export const CanonicalTag = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = normalize(pathname);
    const page = canonical.pages[path];
    const meta = page || canonical.pages["/"];
    const url = `${canonical.origin}${page ? path : "/"}`;
    document.title = meta.title;
    setMeta('meta[name="description"]', meta.description);
    setMeta('meta[property="og:title"]', meta.title);
    setMeta('meta[property="og:description"]', meta.description);
    setMeta('meta[property="og:url"]', url);
    setMeta('meta[name="twitter:title"]', meta.title);
    setMeta('meta[name="twitter:description"]', meta.description);
    setCanonical(page ? url : null);
  }, [pathname]);

  return null;
};
